export const RETURN_CANCEL_STATUS_TAB_STORAGE_KEY = "return_cancel_status_tab";

export const saveReturnCancelStatusTab = (tab) => {
  if (tab === "Returned" || tab === "Cancelled") {
    sessionStorage.setItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY, tab);
  }
};

export const getSavedReturnCancelStatusTab = () => {
  const savedTab = sessionStorage.getItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY);
  return savedTab === "Returned" || savedTab === "Cancelled" ? savedTab : null;
};

export const clearSavedReturnCancelStatusTab = () => {
  sessionStorage.removeItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY);
};

export const consumeSavedReturnCancelStatusTab = () => {
  const savedTab = getSavedReturnCancelStatusTab();
  if (!savedTab) return null;
  clearSavedReturnCancelStatusTab();
  return savedTab;
};
